// ------------------------------
// TOP
// ------------------------------
$(document).ready(function () {

    if ($('.mv').length) {

        $('.mv-slick').slick({
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            draggable: false,
            swipe: false
        });

        $('.mv-slick').on('afterChange', function (event, slick, currentSlide) {
            var currentImg = $(slick.$slides[currentSlide]).find('.mv-slick__img >img');
            var currentTxt = $(slick.$slides[currentSlide]).find('.mv-slick__img-txt >img');

            var tl = gsap.timeline();
            tl.fromTo(currentImg,
                { y: "110%", ease: 'power3.out' },
                { y: "0", ease: 'power3.out', duration: 1 }
            );
            tl.fromTo(currentTxt,
                { y: "110%", ease: 'power3.out' },
                { y: "0", ease: 'power3.out', duration: 1 }
            );
            tl.fromTo([currentImg, currentTxt],
                { opacity: 1, ease: 'power3.out' },
                { opacity: 0, ease: 'power3.out', duration: 1, delay: 1 }
            );
        });

        var tl = gsap.timeline();
        tl.fromTo($('.mv-slick__img >img'),
            { y: "110%", ease: 'power3.out' },
            { y: "0", ease: 'power3.out', duration: 1 }
        );
        tl.fromTo($('.mv-slick__img-txt >img'),
            { y: "110%", ease: 'power3.out' },
            { y: "0", ease: 'power3.out', duration: 1 }
        );
        tl.fromTo([$('.mv-slick__img >img'), $('.mv-slick__img-txt >img')],
            { opacity: 1, ease: 'power3.out' },
            { opacity: 0, ease: 'power3.out', duration: 1, delay: 1 }
        );

    }
    
    if ($('.present-slick').length) {
        $('.present-slick').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            fade: false,
            cssEase: 'linear',
            slidesToShow: 4,
            slidesToScroll: 1,
            draggable: false,
            swipe: false,
            arrows: true,
            prevArrow: '<div class="slide-arrow prev-arrow"></div>',
            nextArrow: '<div class="slide-arrow next-arrow"></div>',
            dots: true,
            dotsClass: 'dots-wrap',
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 919,
                    settings: {
                        slidesToShow: 2,

                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                }
            ]
        });
    }

    if ($('.service-slide').length) {
        gsap.registerPlugin(MotionPathPlugin);
        var cards = gsap.utils.toArray('#items-slide .slide-item');
        var delay = null;
        var screenWidth = $(window).width();

        animateToLeft(cards);

        function animateToLeft(array) {
            if (array.length >= 4) {

                gsap.fromTo(array[3],
                    { x: -149, y: 169, opacity: 1, width: 160, height: 160 },
                    { x: -149, y: 169, opacity: 0, width: 160, height: 160, delay: 0.03, ease: "power2.inOut", onComplete: () => sortArray(array) }
                );

                gsap.fromTo(array[4],
                    { x: 234, y: 124, opacity: 1, width: 160, height: 160 },
                    { x: -149, y: 169, opacity: 1, width: 240, height: 240, ease: "power2.inOut" }
                );

                gsap.fromTo(array[5],
                    { x: 548, y: 32, opacity: 1, width: 360, height: 360 },
                    {
                        x: 234, y: 124, opacity: 1, width: 160, height: 160, ease: "power2.inOut",
                        onStart: function () {
                            $('.slide-focus').removeClass('slide-focus__animL');
                            $('.slide-focus').removeClass('slide-focus__animR');
                            $(array[5]).find('.slide-focus').addClass('slide-focus__animL');
                        }
                    }
                );

                if (screenWidth <= 740) {
                    gsap.fromTo(array[0],
                        { x: 1034, y: 56, opacity: 1, width: 240, height: 240 },
                        {
                            x: 590, y: 68, opacity: 1, width: 260, height: 260, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));

                                animDotSP($('.' + navitem).data("id"));
                            }
                        }
                    );
                } else {
                    gsap.fromTo(array[0],
                        { x: 1034, y: 56, opacity: 1, width: 240, height: 240 },
                        {
                            x: 548, y: 32, opacity: 1, width: 360, height: 360, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));
                            }
                        }
                    );
                }


                gsap.fromTo(array[1],
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160 },
                    { x: 1034, y: 56, opacity: 1, width: 240, height: 240, ease: "power2.inOut" }
                );

                gsap.fromTo(array[2],
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160 },
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160, ease: "power2.inOut" }
                );
            }
        }

        function animateToRight(array) {
            if (array.length >= 4) {

                gsap.fromTo(array[3],
                    { x: -149, y: 169, opacity: 0 },
                    { x: -149, y: 169, opacity: 1, delay: 0.03, ease: "power2.inOut", onComplete: () => sortArray(array) }
                );

                gsap.fromTo(array[4],
                    { x: -149, y: 169, opacity: 1, width: 240, height: 240 },
                    { x: 234, y: 124, opacity: 1, width: 160, height: 160, ease: "power2.inOut" }
                );

                if (screenWidth <= 740) {
                    gsap.fromTo(array[5],
                        { x: 234, y: 124, opacity: 1, width: 160, height: 160 },
                        {
                            x: 590, y: 68, opacity: 1, width: 260, height: 260, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));

                                animDotSP($('.' + navitem).data("id"));
                            }
                        }
                    );
                } else {
                    gsap.fromTo(array[5],
                        { x: 234, y: 124, opacity: 1, width: 160, height: 160 },
                        {
                            x: 548, y: 32, opacity: 1, width: 360, height: 360, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));
                            }
                        }
                    );
                }

                gsap.fromTo(array[0],
                    { x: 548, y: 32, opacity: 1, width: 360, height: 360 },
                    {
                        x: 1034, y: 56, opacity: 1, width: 240, height: 240, ease: "power2.inOut",
                        onStart: function () {
                            $('.slide-focus').removeClass('slide-focus__animL');
                            $('.slide-focus').removeClass('slide-focus__animR');
                            $(array[1]).find('.slide-focus').addClass('slide-focus__animR');
                        }
                    }
                );

                gsap.fromTo(array[1],
                    { x: 1034, y: 56, opacity: 1, width: 240, height: 240 },
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160, ease: "power2.inOut" }
                );

                gsap.fromTo(array[2],
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160 },
                    { x: 1399, y: 22, opacity: 0, width: 240, height: 240, ease: "power2.inOut" }
                );
            }
        }

        function animateToRightBtn(array) {
            if (array.length >= 4) {

                gsap.fromTo(array[4],
                    { x: -149, y: 169, opacity: 0, width: 240, height: 240 },
                    { x: -149, y: 169, opacity: 1, width: 240, height: 240, delay: 0.03, ease: "power2.inOut", onComplete: () => sortArray(array) }
                );

                gsap.fromTo(array[5],
                    { x: -149, y: 169, opacity: 1, width: 240, height: 240 },
                    { x: 234, y: 124, opacity: 1, width: 160, height: 160, ease: "power2.inOut" }
                );

                if (screenWidth <= 740) {
                    gsap.fromTo(array[0],
                        { x: 234, y: 124, opacity: 1, width: 160, height: 160 },
                        {
                            x: 590, y: 68, opacity: 1, width: 260, height: 260, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));

                                animDotSP($('.' + navitem).data("id"));
                            }
                        }
                    );
                } else {
                    gsap.fromTo(array[0],
                        { x: 234, y: 124, opacity: 1, width: 160, height: 160 },
                        {
                            x: 548, y: 32, opacity: 1, width: 360, height: 360, ease: "power2.inOut",
                            onStart: function () {
                                $('.slide-item').removeClass('slide-active');
                                $(array[0]).addClass('slide-active');

                                $('.slide-control__nav-item').removeClass('nav-active');
                                var navitem = $(array[0]).data("item");
                                $('.' + navitem).addClass('nav-active');

                                animDot($('.' + navitem).data("id"));

                            }
                        }
                    );
                }


                gsap.fromTo(array[1],
                    { x: 548, y: 32, opacity: 1, width: 360, height: 360 },
                    {
                        x: 1034, y: 56, opacity: 1, width: 240, height: 240, ease: "power2.inOut",
                        onStart: function () {
                            $('.slide-focus').removeClass('slide-focus__animL');
                            $('.slide-focus').removeClass('slide-focus__animR');
                            $(array[1]).find('.slide-focus').addClass('slide-focus__animR');
                        }
                    }
                );

                gsap.fromTo(array[2],
                    { x: 1034, y: 56, opacity: 1, width: 240, height: 240 },
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160, ease: "power2.inOut" }
                );

                gsap.fromTo(array[3],
                    { x: 1399, y: 22, opacity: 1, width: 160, height: 160 },
                    { x: 1399, y: 22, opacity: 0, width: 240, height: 240, ease: "power2.inOut" }
                );
            }
        }

        $(".slide-next").on("click", function () {
            var firstElem = cards.shift();
            cards.push(firstElem);
            animateToLeft(cards);

        });

        $(".slide-prev").on("click", function () {
            animateToRight(cards);
            var lastElem = cards.pop();
            cards.unshift(lastElem);

        });

        function sortArray(array) {
            clearTimeout(delay);
            delay = setTimeout(function () {
                var firstElem = cards.shift();
                cards.push(firstElem);
                animateToLeft(cards);
            }, 3000);
        }

        function goToSlide(array, targetElement) {
            // get element index
            let targetId = $(targetElement).attr('id');
            let targetPos = $(targetElement).data('position');
            let targetPosOld = $('.slide-active').data('position');

            // let targetIndex = array.indexOf(targetElement);
            let targetIndex = array.findIndex(function (el) {
                return $(el).attr('id') === targetId;  // ou $(el).attr('id') === targetId se estiver usando id
            });

            // Reorder the array so that targetIndex is the main focus
            cards = [...array.slice(targetIndex), ...array.slice(0, targetIndex)]

            if (targetPos > targetPosOld) {
                animateToLeft(cards);
            } else {
                animateToRightBtn(cards);
            }
        }

        $(".slide-control__nav-item").on("click", function () {

            let targetId = $(this).data('id');
            let targetElement = $('#' + targetId);
            goToSlide(cards, targetElement);
        });

        function translateDot(fromx, fromy, tox, toy) {
            gsap.fromTo($('.active-dot'),
                { x: fromx, y: fromy, opacity: 1 },
                { x: tox, y: toy, opacity: 1, ease: "power2.inOut" }
            );
        }

        // get element translated values
        function getTranslateValues(element) {
            var transformMatrix = $(element).css("transform");

            if (transformMatrix !== 'none') {
                var matrixValues = transformMatrix.match(/matrix.*\((.+)\)/)[1].split(', ');
                return {
                    translateX: parseFloat(matrixValues[4]),
                    translateY: parseFloat(matrixValues[5])
                };
            } else {
                return { translateX: 0, translateY: 0 };
            }
        }

        function animDot(dot) {
            // dot animation
            var translateValues = getTranslateValues('.active-dot');
            elem = $('.active-dot');
            arrow = $('.slide-arrow__icon');
            if (dot === 'item-tv') {
                translateDot(translateValues.translateX, translateValues.translateY, 0, 0);
                gsap.to(elem, { backgroundColor: '#E40077', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#E40077', ease: "power2.inOut" });
            } else if (dot === 'item-net') {
                translateDot(translateValues.translateX, translateValues.translateY, 94, 0);
                gsap.to(elem, { backgroundColor: '#0085CD', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#0085CD', ease: "power2.inOut" });
            } else if (dot === 'item-mobile') {
                translateDot(translateValues.translateX, translateValues.translateY, 188, 0);
                gsap.to(elem, { backgroundColor: '#00A4A8', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#00A4A8', ease: "power2.inOut" });
            } else if (dot === 'item-insurance') {
                translateDot(translateValues.translateX, translateValues.translateY, 282, 0);
                gsap.to(elem, { backgroundColor: '#E50346', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#E50346', ease: "power2.inOut" });
            } else if (dot === 'item-phone') {
                translateDot(translateValues.translateX, translateValues.translateY, 376, 0);
                gsap.to(elem, { backgroundColor: '#00A33E', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#00A33E', ease: "power2.inOut" });
            } else if (dot === 'item-other') {
                translateDot(translateValues.translateX, translateValues.translateY, 470, 0);
                gsap.to(elem, { backgroundColor: '#0A308F', ease: "power2.inOut" });
                gsap.to(arrow, { background: '#0A308F', ease: "power2.inOut" });
            }
        }

        function animDotSP(dot) {
            // dot animation
            navitem = $('.nav-active .slide-control__nav-dot');
            allDot = $('.slide-control__nav-dot');
            nav = $('.slide-control__nav');

            gsap.to(allDot, { backgroundColor: '#CCCCCC', ease: "power2.inOut" });
            if (dot === 'item-tv') {
                gsap.to(nav, { x: 244, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#E40077', ease: "power2.inOut" });
            } else if (dot === 'item-net') {
                gsap.to(nav, { x: 140, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#0085CD', ease: "power2.inOut" });
            } else if (dot === 'item-mobile') {
                gsap.to(nav, { x: 48, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#00A4A8', ease: "power2.inOut" });
            } else if (dot === 'item-insurance') {
                gsap.to(nav, { x: -45, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#E50346', ease: "power2.inOut" });
            } else if (dot === 'item-phone') {
                gsap.to(nav, { x: -140, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#00A33E', ease: "power2.inOut" });
            } else if (dot === 'item-other') {
                gsap.to(nav, { x: -234, ease: "power2.inOut" });

                gsap.to(navitem, { backgroundColor: '#0A308F', ease: "power2.inOut" });
            }
        }
    }

    if ($('.meetycv').length) {
        $('.meet__link').hover(
            function () {
                const tl = gsap.timeline();
                tl.to(".button-grow", {
                    backgroundSize: '200% 200%',
                    color: '#262626',
                    duration: 0.1,
                    ease: "power1.inOut"
                })
                tl.to(".button-grow", {
                    scale: 1.2,
                    duration: 0.2,
                    ease: "power1.inOut"
                })
                    .to(".button-grow", {
                        scale: 1,
                        duration: 0.1,
                        ease: "power1.inOut"
                    });
            }, function () {
                gsap.to(".button-grow", {
                    backgroundSize: '0% 0%',
                    color: '#ffffff',
                    duration: 0.1,
                    ease: 'power1.inOut'
                });
            }
        );
    }

    if ($('.campaign-slick').length) {

        $('.campaign-slick').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            slidesToShow: 4,
            slidesToScroll: 1,
            draggable: false,
            swipe: false,
            arrows: true,
            prevArrow: '<div class="slide-arrow prev-arrow"></div>',
            nextArrow: '<div class="slide-arrow next-arrow"></div>',
            dots: true,
            dotsClass: 'dots-wrap',
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 919,
                    settings: {
                        slidesToShow: 2,

                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

    }

    if ($('.member__campaign-slick').length) {

        $('.member__campaign-slick').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            slidesToShow: 3.2,
            slidesToScroll: 1,
            draggable: false,
            swipe: false,
            arrows: true,
            prevArrow: '<div class="slide-arrow prev-arrow"></div>',
            nextArrow: '<div class="slide-arrow next-arrow"></div>',
            dots: true,
            dotsClass: 'dots-wrap',
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 919,
                    settings: {
                        slidesToShow: 2,

                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

    }


    if ($('#particles-top').length) {
        particles('particles-top');
    }
});

function particles(elementId) {
    particlesJS(elementId,

        {
            "particles": {
                "number": {
                    "value": 20,
                    "density": {
                        "enable": true,
                        "value_area": 800
                    }
                },
                "color": {
                    "value": ["#8CC0E5", "#A7EAC4", "#AAF3B7", "#D0E396", "#CAF097", "#FFB4D8", "#FFAEAE", "#2DA8E8", "#169BE0", "#CCFFB4", "#FFEDAE", "#2C86B5", "#E3BBF6", "#D4E6F6", "#ECCAFF", "#64BE9E", "#62CA8E"]
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#000000"
                    },
                    "polygon": {
                        "nb_sides": 5
                    },
                    "image": {
                        "src": "img/github.svg",
                        "width": 100,
                        "height": 100
                    }
                },
                "opacity": {
                    "value": 1,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 24,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 4,
                        "size_min": 0.3,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": false,
                    "distance": 150,
                    "color": "#ffffff",
                    "opacity": 0.4,
                    "width": 1
                },
                "move": {
                    "enable": true,
                    "speed": 5,
                    "direction": "none",
                    "random": true,
                    "straight": false,
                    "out_mode": "out",
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 600
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false,
                        "mode": "repulse"
                    },
                    "onclick": {
                        "enable": false,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    "grab": {
                        "distance": 400,
                        "line_linked": {
                            "opacity": 1
                        }
                    },
                    "bubble": {
                        "distance": 400,
                        "size": 40,
                        "duration": 2,
                        "opacity": 8,
                        "speed": 3
                    },
                    "repulse": {
                        "distance": 200
                    },
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true,
            "config_demo": {
                "hide_card": false,
                "background_color": "#b61924",
                "background_image": "",
                "background_position": "50% 50%",
                "background_repeat": "no-repeat",
                "background_size": "cover"
            }
        }

    );
}

// ------------------------------
// 半角フィールド
// ------------------------------
$(document).ready(function() {

    function kanaFullToHalf(str) {
        const kanaMap = {
            "ガ": "ｶﾞ",
            "ギ": "ｷﾞ",
            "グ": "ｸﾞ",
            "ゲ": "ｹﾞ",
            "ゴ": "ｺﾞ",
            "ザ": "ｻﾞ",
            "ジ": "ｼﾞ",
            "ズ": "ｽﾞ",
            "ゼ": "ｾﾞ",
            "ゾ": "ｿﾞ",
            "ダ": "ﾀﾞ",
            "ヂ": "ﾁﾞ",
            "ヅ": "ﾂﾞ",
            "デ": "ﾃﾞ",
            "ド": "ﾄﾞ",
            "バ": "ﾊﾞ",
            "ビ": "ﾋﾞ",
            "ブ": "ﾌﾞ",
            "ベ": "ﾍﾞ",
            "ボ": "ﾎﾞ",
            "パ": "ﾊﾟ",
            "ピ": "ﾋﾟ",
            "プ": "ﾌﾟ",
            "ペ": "ﾍﾟ",
            "ポ": "ﾎﾟ",
            "ヴ": "ｳﾞ",
            "ヷ": "ﾜﾞ",
            "ヺ": "ｦﾞ",
            "ア": "ｱ",
            "イ": "ｲ",
            "ウ": "ｳ",
            "エ": "ｴ",
            "オ": "ｵ",
            "カ": "ｶ",
            "キ": "ｷ",
            "ク": "ｸ",
            "ケ": "ｹ",
            "コ": "ｺ",
            "サ": "ｻ",
            "シ": "ｼ",
            "ス": "ｽ",
            "セ": "ｾ",
            "ソ": "ｿ",
            "タ": "ﾀ",
            "チ": "ﾁ",
            "ツ": "ﾂ",
            "テ": "ﾃ",
            "ト": "ﾄ",
            "ナ": "ﾅ",
            "ニ": "ﾆ",
            "ヌ": "ﾇ",
            "ネ": "ﾈ",
            "ノ": "ﾉ",
            "ハ": "ﾊ",
            "ヒ": "ﾋ",
            "フ": "ﾌ",
            "ヘ": "ﾍ",
            "ホ": "ﾎ",
            "マ": "ﾏ",
            "ミ": "ﾐ",
            "ム": "ﾑ",
            "メ": "ﾒ",
            "モ": "ﾓ",
            "ヤ": "ﾔ",
            "ユ": "ﾕ",
            "ヨ": "ﾖ",
            "ラ": "ﾗ",
            "リ": "ﾘ",
            "ル": "ﾙ",
            "レ": "ﾚ",
            "ロ": "ﾛ",
            "ワ": "ﾜ",
            "ヲ": "ｦ",
            "ン": "ﾝ",
            "ァ": "ｧ",
            "ィ": "ｨ",
            "ゥ": "ｩ",
            "ェ": "ｪ",
            "ォ": "ｫ",
            "ッ": "ｯ",
            "ャ": "ｬ",
            "ュ": "ｭ",
            "ョ": "ｮ",
            "。": "｡",
            "、": "､",
            "ー": "ｰ",
            "「": "｢",
            "」": "｣",
            "・": "･",
            "　": " "
        };
        const reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        return str.replace(reg, function(s) {
            return kanaMap[s];
        }).replace(/゛/g, 'ﾞ').replace(/゜/g, 'ﾟ');
    }

    // ページロード時に`#furiclient`フィールドの全角カタカナを半角に変換
    $("#furiclient").val(function(index, value) {
        return kanaFullToHalf(value);
    });

    // フォーカスが外れたときに全角カタカナを半角に変換
    $("#furiclient").on("blur", function() {
        this.value = kanaFullToHalf(this.value);
    });
});